import { RM10_01 } from "./RM10_01";

export const RM10 = {
    "columns": 4,
    "rows": 1,
    "visual": {
        "id": 1,
        "type": "bar",
        "colorTheme": 'colorTheme1',
        "title": "ADVANCED CALLS",
        "orientation": "vertical",
        "xAxis": "",
        "yAxis": "",
        "binding": {
            "data": {
                "series": [
                    {
                        "name": 'Count',
                        "value": 'TotalCount',
                        "type": 'column'
                    }
                ],
                "title": 'SubCycle',
                "endpoint": "RM10",
                "parameters": [
                    { "key": "CycleCode", "value": "CP1" },
                    { "key": "CycleYear", "value": "2026" },
                    { "key": "RegionCode", "value": "" },
                ]
            },
            "context": {
                "point": {
                    "onClick": RM10_01
                }
            }
        }
    }
}